import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
// report-common
import { getReportSelectors } from '../../../report-common/selectors';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('reportGeoFencingZone');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.compose(
    R.map((item) => R.assoc('disabled', G.isFalse(R.prop('editable', item)), item)),
    R.sortBy(R.prop('index')),
    R.values,
  )(R.or(itemList, {})),
);

const makeSelectAvailableReportGeoFencingZoneList = () => createSelector(
  store,
  ({ availableList }) => availableList,
);

export {
  // report
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectPageVisited,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  // report
  makeSelectAvailableReportGeoFencingZoneList,
};
